import { render, staticRenderFns } from "./recreateRequest.vue?vue&type=template&id=59b73170&scoped=true"
import script from "./recreateRequest.vue?vue&type=script&lang=js"
export * from "./recreateRequest.vue?vue&type=script&lang=js"
import style0 from "./recreateRequest.vue?vue&type=style&index=0&id=59b73170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b73170",
  null
  
)

export default component.exports